import localization from '../../../../shared/strings';
import { AGGREGATED_FIELD_STATE } from '../../../../store/products/helpers/aggregatedFieldState';
import { formatAggregatedInputValue } from './formatAggregatedInputValue';

const l10n = localization.PRODUCT_INFO.aggregated;

export const mapAggregatedFieldToInputProps = (field) => {
  if (!field) {
    return {
      value: '',
      placeholder: '',
      readOnly: true,
      isMultiple: false,
      isEmpty: true,
    };
  }

  if (field.state === AGGREGATED_FIELD_STATE.COMMON) {
    return {
      value: formatAggregatedInputValue(field.value),
      placeholder: '',
      readOnly: false,
      isMultiple: false,
      isEmpty: false,
      stats: field.stats,
    };
  }

  if (field.state === AGGREGATED_FIELD_STATE.MULTIPLE) {
    return {
      value: '',
      placeholder: l10n.multipleValues,
      readOnly: false,
      isMultiple: true,
      isEmpty: false,
      stats: field.stats,
    };
  }

  if (field.state === AGGREGATED_FIELD_STATE.EMPTY) {
    return {
      value: '',
      placeholder: '',
      readOnly: false,
      isMultiple: false,
      isEmpty: true,
      stats: field.stats,
    };
  }

  return {
    value: '',
    placeholder: '',
    readOnly: true,
    isMultiple: false,
    isEmpty: true,
  };
};

export default mapAggregatedFieldToInputProps;
